import {
  anyPass,
  curry,
  compose,
  complement,
  map,
  isEmpty,
  filter
} from 'ramda'
import { RouteConfig as Route } from 'vue-router'
import { randKey } from '@/utils/random'
import { ChainFn, TestFn, FilterFn } from '@/models/helpers/function'

export const getChildren = (route: Route) => route.children || []

export const hasChildren = compose(complement(isEmpty), getChildren)

/**
 * 将 fn 作用于每个子节点
 * 先作用于父节点, 后作用于子节点
 * @param fn
 */
export const deepMap = (fn: ChainFn<Route>): ChainFn<Route[]> =>
  compose(map(_deepMap(fn)), map(fn))

function _deepMap(fn: ChainFn<Route>) {
  return (route: Route) => ({
    ...route,
    children: deepMap(fn)(getChildren(route))
  })
}

/**
 * 过滤不满足以下要求的路由
 * 1. 自身不满足条件
 * 2. 所有子节点均不满足条件
 * @param testFn 测试函数
 */
export const deepFilter: FilterFn<Route> = testFn =>
  compose(filter(anyPass([hasChildren, testFn])), map(_deepFilter(testFn)))

function _deepFilter(testFn: TestFn<Route>) {
  return (route: Route) => ({
    ...route,
    children: deepFilter(testFn)(getChildren(route))
  })
}

/**
 * 为每个路由添加以地址开头的唯一id
 */
export const addKey = curry(
  (pre: string, route: Route): Route => {
    const path = pre ? `${pre}/${route.path}` : route.path
    if (hasChildren(route)) {
      route.children = map(addKey(path), getChildren(route)) as any
    }
    return { ...route, meta: { ...route.meta, key: path + randKey() } }
  }
)

/**
 * TODO need refactor
 * @param key
 */
export const getFullPath = (key: string) => key.slice(0, key.lastIndexOf('_'))
